export default "__VITE_ASSET__RrPcw25T__"